import { FC } from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import s from './timeline.module.css';

export interface TimelineStepType {
  id: string;
  label: string;
  date: string;
  failed?: boolean;
}

interface Props {
  steps: TimelineStepType[];
}

const success = 'green';
const fail = 'red';
const colors = [
  'orange',
  'purple',
  'blue',
  'pink',
  'aquamarine',
  'yellow',
  'brown',
  'gray',
  'violet',
  'cyan',
];

export const Timeline: FC<Props> = ({ steps }) => {
  return (
    <ul className={s.component}>
      {steps.map(({ id, label, date, failed }, index) => {
        let color;
        // Если это последний элемент, выбираем цвет в зависимости от пропса failed
        if (index === steps.length - 1) {
          color = failed ? fail : success;
        } else {
          color = colors[index];
        }

        return (
          <li
            key={id}
            className={s.item}
            style={{ '--random-color': color } as React.CSSProperties}
          >
            <div className={s.line} />
            <div className={s.content}>
              <h4>{label}</h4>
              <span className={s.date}>
                <AiOutlineClockCircle data-testid="timeline-icon" />
                {date}
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
